import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../shared/shared.service';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Subject } from 'rxjs';
import { CountryService } from './country.service';

@Component({
  selector: 'app-country',
  templateUrl: './country.component.html',
  styleUrls: ['./country.component.scss']
})

export class CountryComponent implements OnInit {
  bucketurl = environment.bucketUrl;
  displayedColumns: string[] = ['SNo', 'country_name', 'country_code', 'status', 'action'];
  public ELEMENT_DATA: any = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);

  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  countryForm: FormGroup;
  isLoading: Subject<boolean> = new Subject<boolean>();

  constructor(private toastr: ToastrService, private fb: FormBuilder, private sharedService: SharedService, private countryService: CountryService) {
    this.countryForm = this.fb.group({
      countryName: ['', Validators.required],
      countryCode: ['', Validators.required],
      status: ['', Validators.required]
    });
  }

  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;

  ngOnInit() {
    this.getList();
  }

  get f() { return this.countryForm.controls; }

  add() {
    this.isCreate = true;
  }

  selectedObject: any = {}
  editData(object: any) {
    this.isEdit = true;
    this.selectedObject = object;
    this.countryForm.patchValue({
      countryName: object.country_name,
      countryCode: object.country_code,
      status: object.status ? 1 : 0
    })
  }

  back() {
    this.clearForm();
    this.selectedObject = {};
    this.isCreate = false;
    this.isEdit = false;
    this.getList();
  }

  create() {
    this.submitted = true
    if (this.countryForm.valid) {
      const countryData = this.countryForm.value;
      let obj = {
        "country_name": countryData.countryName,
        "country_code": countryData.countryCode,
        "status": parseInt(countryData.status),
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.countryService.createCountry(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Country created successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  update() {
    this.submitted = true
    if (this.countryForm.valid) {
      const countryData = this.countryForm.value;
      let obj = {
        "country_name": countryData.countryName,
        "country_code": countryData.countryCode,
        "status": parseInt(countryData.status),
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.countryService.updateCountry(obj, this.selectedObject.id).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Country updated successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  clearForm() {
    this.submitted = false;
    this.countryForm.patchValue({
      countryCode: '',
      countryName: '',
      status: ''
    });
  }

  allowNumbersHyphenOnly(event: any) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[0-9\-]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  getList() {
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.countryService.getCountry().subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.ELEMENT_DATA = responseData.data
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }
}
